export const silaeConfigurationCacheKeys = {
  silae_config: () => ['silae_config'] as const,
  silae_list_record: () => ['silae_list_record'] as const
}
